import {useState} from 'react';
import {NetworkDetailsFormValues, NetworkNodeFieldPath} from '../../types';
import BranchDetails from './BranchDetails';
import BuildingDetails from './BuildingDetails';
import ContactDetails from './ContactDetails';
import {useFormContext} from 'react-hook-form';

type Props = {
  selectedFieldPath: NetworkNodeFieldPath | null;
};

function DetailsForm({selectedFieldPath}: Props) {
  const {watch} = useFormContext<NetworkDetailsFormValues>();
  const fieldsExists =
    selectedFieldPath && watch(selectedFieldPath) !== undefined;

  const [expandedSet, setExpandedSet] = useState<Set<string>>(
    new Set(['branch', 'building', 'contact']),
  );

  const toggleExpand = (id: string) => {
    setExpandedSet(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return (
    <div className="flex-1 min-h-0 overflow-y-auto border border-gray70 rounded-lg px-4 py-3">
      {fieldsExists ? (
        <div className="flex flex-col gap-3">
          <BranchDetails
            selectedFieldPath={selectedFieldPath}
            expanded={expandedSet.has('branch')}
            onToggle={toggleExpand}
          />

          <BuildingDetails
            selectedFieldPath={selectedFieldPath}
            expanded={expandedSet.has('building')}
            onToggle={toggleExpand}
          />

          <ContactDetails
            selectedFieldPath={selectedFieldPath}
            expanded={expandedSet.has('contact')}
            onToggle={toggleExpand}
          />
        </div>
      ) : (
        <div className="w-full h-full flex justify-center items-center">
          <p className="m-0 text-base text-darkerGray">
            בחרו ענף בעץ כדי לערוך את פרטיו
          </p>
        </div>
      )}
    </div>
  );
}

export default DetailsForm;
